export default __webpack_public_path__ + "static/media/article1.b351751b.png";